import styles from './Footer.module.scss';
import {Link} from 'react-router-dom';
import {HashLink} from "react-router-hash-link";


export const FooterContainer = () => {
    return (
        <div className={styles['footer-container']}>
            <div className={styles['black-bg']}>
                <div className={styles['full-width-row']}>
                    <div className={styles['card']}>
                        <div className={styles['primary-row']}>
                            <div className={styles['top-container']}>
                                <div className={styles['top-bar']}>
                                    <div className={styles['logo']}>
                                        <img
                                            className={styles['svg-mark']}
                                            src="./sw-logo-mark.svg"
                                            alt="stamey-white-logo"
                                        />
                                        <img
                                            className={styles['stamey-white']}
                                            src="./Logo.svg"
                                            alt="stamey-white-logo"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={styles['links']}>
                                <div className={styles['nav']}>
                                    <HashLink smooth to="/#home"><p>HOME</p></HashLink>
                                    <HashLink smooth to="/#about-me"><p>ABOUT ME</p></HashLink>
                                    <HashLink smooth to="/#services"><p>SERVICES</p></HashLink>
                                </div>
                                <div className={styles['nav']}>
                                    <a href="https://blog.stameywhite.com/" target="_blank"
                                       rel="noopener noreferrer">
                                        <p>BLOG</p>
                                    </a>
                                    <Link to="/contact"><p>CONTACT</p></Link>
                                </div>
                            </div>
                        </div>
                        <div className={styles['divider']}>
                            <img src="./divider.svg" alt="divider-icon"/>
                        </div>
                        <div className={styles['copy-write']}>
                            <p>© 2024 Stamey-White</p>
                            <div className={styles['tos-pp']}>
                                <Link to="/terms-of-service">
                                    <p>Terms of Service</p>
                                </Link>
                                <Link to="/privacy-policy">
                                    <p>Privacy Policy</p>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
};